import { render, staticRenderFns } from "./pwa_qr_payments.vue?vue&type=template&id=3bcac256&scoped=true&"
import script from "./pwa_qr_payments.vue?vue&type=script&lang=js&"
export * from "./pwa_qr_payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcac256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcac256')) {
      api.createRecord('3bcac256', component.options)
    } else {
      api.reload('3bcac256', component.options)
    }
    module.hot.accept("./pwa_qr_payments.vue?vue&type=template&id=3bcac256&scoped=true&", function () {
      api.rerender('3bcac256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/location/tabs_qr/pwa_qr_payments.vue"
export default component.exports